"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../../schema");
const value = schema_1.Schema.number()
    .expiration(31536000)
    .unit("mg/L")
    .integer()
    .min(0)
    .max(99999)
    .interpretation({ vocab: "ktx", code: "lab_CRP" })
    .tag({ vocab: "snomed", code: "55235003", source: "synonym" })
    .tag({ vocab: "loinc", code: "1988-5", source: "synonym" })
    .tag({ vocab: "ktx", code: "lab_procedure" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ value });
